import { render, staticRenderFns } from "./AttachedPositionsToRole.vue?vue&type=template&id=6c1ea22c&scoped=true"
import script from "./AttachedPositionsToRole.vue?vue&type=script&lang=js"
export * from "./AttachedPositionsToRole.vue?vue&type=script&lang=js"
import style0 from "./AttachedPositionsToRole.vue?vue&type=style&index=0&id=6c1ea22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ea22c",
  null
  
)

export default component.exports